import { ViewerApp } from './main/viewer';

export default ViewerApp;
